module.exports = __webpack_public_path__ + "static/media/lobbyA.7011564d.jpg";